import { createAction, props } from '@ngrx/store';
import { LoginResponse } from '@/auth/interface/auth.interface';

export const setLoggedUserData = createAction(
  '[Login] Set User Data',
  props<LoginResponse>(),
);
